import { postRequest } from "../utils/axiosHandler";

export const kokoPay= async (kokoPayData) => {
  // if (!window.kokoPayData) {
  //   console.error("KOKO Pay data is missing.");
  //   return;
  // }

  try {
    const responseData = await postRequest("/api/vm/user/kokoPay", kokoPayData);

    //console.log("KOKO Pay response:", responseData);

    if (responseData) {
      //console.log("KOKO Pay payment process initiated successfully.");

      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://prodapi.paykoko.com/api/merchants/orderCreate";

      Object.entries(responseData).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      //console.log("Form submitted, user redirected to PayKoko for payment.");
    }
  } catch (error) {
    console.error("Error during KOKO Pay request:", error);
  }
};